import { MoreButton, Space, theme } from '@/components';
import { EditOutlined, FileSearchOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import { type ComponentProps, type FC, type ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onEdit?: () => void;
  hideEditIcon?: boolean;
  onBrowse?: () => void;
  items?: ComponentProps<typeof MoreButton>['items'];
  additonalItem?: ReactNode;
};

const SPACE_STYLE = { width: '100%', justifyContent: 'center' };

export const TableRowMenuCell: FC<Props> = ({
  onEdit,
  onBrowse,
  hideEditIcon,
  items,
  additonalItem,
}) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const outlinedStyle = useMemo(
    () => ({
      color: token.colorLink,
      fontSize: 21,
    }),
    [token],
  );

  const hasItem = useMemo<boolean>(
    () => !!onEdit || !!onBrowse || !!items?.length,
    [onEdit, onBrowse, items],
  );

  return (
    <Space style={SPACE_STYLE} split={<Divider type="vertical" />}>
      {additonalItem && additonalItem}
      {!hideEditIcon && onEdit && (
        <EditOutlined style={outlinedStyle} onClick={onEdit} />
      )}
      {onBrowse && (
        <FileSearchOutlined style={outlinedStyle} onClick={onBrowse} />
      )}
      {hasItem && (
        <MoreButton
          items={[
            onEdit ? { key: 'edit', label: t('edit'), onClick: onEdit } : null,
            onBrowse
              ? { key: 'details', label: t('details'), onClick: onBrowse }
              : null,
            ...(items ?? []),
          ]}
        />
      )}
    </Space>
  );
};
